import React from 'react';


const IntroSubTitle = (props) =>{
    const {fontSize,lineHeight,children} = props;

    var style;

    if(window.innerWidth > 1000){

      style = {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '900',
        fontSize: (fontSize || '72px'),
        lineHeight: (lineHeight || '80px'),
        textTransform: 'uppercase',
        color:'#8DC63F',
        display:'inline-block',
        width:'100%',
        padding:'0 2px',
        marginTop:'12px',
        position:'relative',

      }
    }else{

      style = {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '900',
        fontSize: (fontSize || '8.5vw'),
        lineHeight: (lineHeight || '8.8vw'),
        textTransform: 'uppercase',
        color: '#8DC63F',
        display:'inline-block',
        padding:'0 2px',
        margin: 0
      }

    }

    return <p className="intro-subtitle" style={style}>{children}</p>;
}

export default IntroSubTitle;